<template>
  <div>
    <DsfrPagination class="mb-6" v-model="page" :length="Math.ceil(concernsCount / limit)" v-if="showPagination" />
    <v-sheet fluid height="200" v-if="inProgress">
      <v-progress-circular indeterminate style="left: 50%; top: 50%"></v-progress-circular>
    </v-sheet>
    <v-row v-else>
      <v-col cols="12" sm="6" md="4" height="100%" v-for="concerns in concerns_list" :key="`issue-${concerns.id}`">
        <ConcernsCard class="fill-height" :concerns="concerns" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        height="100%"
        class="d-flex flex-column"
        v-if="loggedUser.job == 'RESEARCHER' || loggedUser.job == 'NUTRITIONIST'"
      >
        <v-card
          class="d-flex flex-column align-center justify-center dsfr"
          outlined
          min-height="220"
          height="80%"
          :to="{ name: 'CreateConcerns' }"
        >
          <v-icon size="100" class="primary--text">mdi-plus</v-icon>
          <v-card-text class="font-weight-bold pt-0 text-center primary--text text-body-1">
            Ajouter une nouvelle problématique
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <DsfrPagination class="my-6" v-model="page" :length="Math.ceil(concernsCount / limit)" />
  </div>
</template>

<script>
import ConcernsCard from "./ConcernsCard"
import DsfrPagination from "@/components/DsfrPagination"

export default {
  name: "ConcernsPagination",
  components: { ConcernsCard, DsfrPagination },
  data() {
    return {
      limit: 6,
      page: null,
      concerns_list: null,
      concernsCount: null,
      canteenName: null,
      searchTerm: null,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
      },
      inProgress: null,
    }
  },
  computed: {
    loading() {
      return this.concernsCount === null
    },
    offset() {
      return (this.page - 1) * this.limit
    },
    userPermissions() {
      return this.$store.state.userPermissions
    },
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
  methods: {
    search() {
      if (this.searchTerm && this.options.page !== 1) {
        this.options.page = 1
      } else {
        this.$router.push({ query: this.getUrlQueryParams() }).catch(() => {})
      }
    },
    getUrlQueryParams() {
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      return urlQueryParams
    },
    fetchCurrentPage() {
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      this.$store
        .dispatch("fetchAllConcerns", { offset: this.offset, search: this.searchTerm })
        .then((response) => {
          console.log(response)
          this.concerns_list = response
          this.concernsCount = response.length
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    clearSearch() {
      this.searchTerm = ""
      this.search()
    },
    updateRoute() {
      const query = { page: this.page }
      if (this.$route.query.page) {
        this.$router.push({ query }).catch(() => {})
      } else {
        this.$router.replace({ query }).catch(() => {})
      }
    },
    populateParameters() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1
    },
    showPagination() {
      return this.concernsCount > this.limit
    },
  },
  watch: {
    page() {
      this.updateRoute()
    },
    $route(newRoute, oldRoute) {
      this.concerns_list = null
      if (newRoute.query.etiquette !== oldRoute.query.etiquette) {
        this.concernsCount = null
      }
      this.populateParameters()
      this.fetchCurrentPage()
    },
  },
  mounted() {
    this.populateParameters()
    if (Object.keys(this.$route.query).length > 0) {
      this.fetchCurrentPage()
    }
  },
}
</script>
